<style lang="scss" scoped>
	.container {

		// 整体表单
		.form-container {

			// 标签
			.tag-container {
				//margin-top: 24px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 20px;

				// 左侧
				.left {
					display: flex;
					align-items: center;

					.icon {
						display: inline-block;
						width: 5px;
						height: 16px;
						background: #419FFF;
					}

					.txt {
						display: inline-block;
						font-weight: 400;
						font-size: 16px;
						color: #303133;
						margin-left: 12px;
					}
				}

				// 右侧
				.right {
					display: flex;
					align-items: center;
				}
			}

			// 文件
			.file-container {
				margin-top: 20px;
				margin-bottom: 20px;

				.file-span {
					height: 24px;
					line-height: 24px;
					display: inline-block;
					padding: 1px 8px 1px 8px;
					border-radius: 4px;
					background-color: #f4f4f5;
					font-size: 12px;
					color: #909399;
					margin-right: 8px;

					#icon {
						margin-left: 5px;
					}
				}
			}
		}

		.gk-html {
			text-align: center !important;
		}

		.gk-html /deep/ table {
			color: #303133 !important;
		}

		.gk-html /deep/ table tbody tr:first-child {
			background-color: #909399 !important;
			color: #FFFFFF IM !important;
		}

		.gy-html {
			margin-top: 10px;
			text-align: center !important;
		}

		.gy-html /deep/ table {
			color: #303133 !important;
		}

		.gy-html /deep/ table tbody tr:first-child {
			background-color: #909399 !important;
			color: #FFFFFF IM !important;
		}

		.tj-html {
			margin-top: 10px;
			text-align: center !important;
		}

		.tj-html /deep/ table {
			color: #303133 !important;
		}

		.tj-html /deep/ table tbody tr:first-child {
			background-color: #909399 !important;
			color: #FFFFFF IM !important;
		}
	}
</style>

<style scoped>
	.tableInputNumber /deep/ .el-input .el-input__inner {
		width: 100px;
	}
</style>
<template>
	<div>
		<div class="container">
			<div class="form-container">
				<el-form ref="form" :rules="rules" :model="form" :inline="true" :label-width="formLabelWidth"
					size="mini">
					<!--工艺文档信息-->
					<div class="tag-container">
						<div class="left">
							<span class="icon" />
							<span class="txt">{{$t('gongyiwendangxinxi')}}</span>
						</div>
						<div class="right" />
					</div>
					<el-form-item :label="$t('gongyizhinanmingcheng')" prop="name">
						<el-input v-model="form.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shebeimingcheng')" prop="equipmentId">
						<yi_cross_select :component="'web_base_equipment_list'" :max="1" :ids.sync="form.equipmentId">
						</yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('mujubianhao/mingcheng')" prop="modelId">
						<yi_cross_select :selectTitle="'no,name'" :component="'web_base_mould_list'" :max="1"
							:ids.sync="form.modelId">
						</yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('chanpinbianma/mingcheng')" required>
						<yi_cross_select :selectTitle="'code,name'" :component="'web_base_matter_list'" :max="1"
							:ids.sync="form.productId">
						</yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('beizhu')">
						<el-input v-model="form.remark"></el-input>
					</el-form-item>
					<!--工艺卡-->
					<div class="tag-container">
						<div class="left">
							<span class="icon" />
							<span class="txt">{{$t('gongyika')}}</span>
						</div>
						<div class="right" />
					</div>
					<el-row>
						<el-col :span="24">
							<yi_upload
								:accept="'image/png, image/jpeg,image/gif,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel'"
								:ids.sync="form.files" :limit="10"></yi_upload>
						</el-col>
					</el-row>
					<!--工艺参数-->
					<div class="tag-container">
						<div class="left">
							<span class="icon" />
							<span class="txt">{{$t('gongyicanshu')}}</span>
						</div>
						<div class="right" />
					</div>
					<el-row>
						<el-col :span="24">
							<div
								style="margin-left: -60px;font-size: 14px;color: #606266;font-family: Microsoft YaHei UI;">
								<el-form-item :label="$t('quanjupiancha')" prop="item3">
									<el-select v-model="form.item3" @change="changeAllDeviation">
										<el-option v-for="(item, index) in deviation" :key="index" :label="item.label"
											:value="item.value" />
									</el-select>
								</el-form-item>
							</div>
							<el-tabs v-model="topActive">
								<el-tab-pane v-for="top in tab" :key="top.name" :label="top.name" :name="top.name">
									<template v-if="type === 1">
										<el-tabs v-model="subActive">
											<el-tab-pane v-for="sub in form.craftGuideParams" :key="sub.type"
												:label="sub.tabName" :name="sub.tabName">
												<el-table stripe class="dynamic-table" max-height="600"
													:header-cell-style="{background:'#F5F7FA',color:'#606266','font-weight':'700', height:'48px', padding:'0px'}"
													:data="sub.params" size="mini" style="width:100%" border>
													<el-table-column align="center" :show-overflow-tooltip="true">
														<template slot="header">
															<span>{{$t('canshumiaoshu')}}</span>
														</template>
														<template slot-scope="scope">
															<!-- <el-form-item> -->
															<span>{{ scope.row.name }}</span>
															<!-- </el-form-item> -->
														</template>
													</el-table-column>
													<el-table-column width="120">
														<template slot="header">
															<span>{{$t('zhi')}}</span>
														</template>
														<template slot-scope="scope">
															<!-- <el-form-item :label-width="labelWidth"
																:show-message="false" :inline-message="true"> -->
															<el-input-number size="mini" class="tableInputNumber"
																v-model="scope.row.value" :controls="false"
																:precision="2" />
															<!-- </el-form-item> -->
														</template>
													</el-table-column>
													<el-table-column width="120">
														<template slot="header">
															<span>{{$t('shanpiancha')}}</span>
														</template>
														<template slot-scope="scope">
															<!-- <el-form-item :label-width="labelWidth"> -->
															<el-input-number size="mini" class="tableInputNumber"
																v-model="scope.row.upperLimit" :controls="false"
																:precision="2" />
															<!-- </el-form-item> -->
														</template>
													</el-table-column>
													<el-table-column width="120">
														<template slot="header">
															<span>{{$t('xiapiancha')}}</span>
														</template>
														<template slot-scope="scope">
															<!-- <el-form-item :label-width="labelWidth"> -->
															<el-input-number size="mini" class="tableInputNumber"
																v-model="scope.row.lowerLimit" :controls="false"
																:precision="2" />
															<!-- </el-form-item> -->
														</template>
													</el-table-column>
													<el-table-column width="120">
														<template slot="header">
															<span>{{$t('shezhipiancha')}}</span>
														</template>
														<template slot-scope="scope">
															<!-- <el-form-item :label-width="labelWidth"> -->
															<el-select size="mini" class="tableInputNumber"
																v-model="scope.row.percent"
																@change="changeDeviation(scope.$index, sub.type, $event)">
																<el-option v-for="(item, index) in deviation"
																	:key="index" :label="item.label"
																	:value="item.value" />
															</el-select>
															<!-- </el-form-item> -->
														</template>
													</el-table-column>
													<el-table-column width="120">
														<template slot="header">
															<span>{{$t('qiyongyujing')}}</span>
														</template>
														<template slot-scope="scope">
															<el-switch v-model="scope.row.alerts">
															</el-switch>
														</template>
													</el-table-column>
												</el-table>
											</el-tab-pane>
										</el-tabs>
									</template>
									<template v-else>
										<div style="margin-bottom: 10px">
											<div class="gk-html" v-html="gkHtml"></div>
											<div class="gy-html" v-html="gyHtml"></div>
											<div class="tj-html" v-html="tjHtml"></div>
										</div>
									</template>
									<!-- <div style="text-align: right;padding: 10px 0 30px 0" @click="switchView">切换视图</div> -->
								</el-tab-pane>
							</el-tabs>
						</el-col>
					</el-row>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'

	export default {
		data() {
			return {
				labelWidth: 0,
				type: 1,
				gkHtml: '',
				gyHtml: '',
				tjHtml: '',
				form: {
					name: '',
					equipmentId: '',
					modelId: '',
					productId: '',
					remark: '',
					files: [],
					craftGuideParams: [],
					item3: ''
				},
				rules: {
					name: [{
						required: true,
						message: this.$t('qingshuru'),
						trigger: ['blur', 'change']
					}],
					equipmentId: [{
						required: true,
						message: this.$t('qingshuru'),
						trigger: ['blur', 'change']
					}],
					modelId: [{
						required: true,
						message: this.$t('qingshuru'),
						trigger: ['blur', 'change']
					}]
				},
				labelWidth: '70px',
				labelPosition: 'left',
				fileList: [],
				name: 'files',
				headers: {
					Authorization: Vue.prototype.store.state.token
				},
				domain: process.env.NODE_ENV == "development" ? global.URL_DEV_API_BASE_DOMAIN +
					'/web/customer/files/upload?publicly=false' : global
					.URL_PROD_API_BASE_DOMAIN + '/web/customer/files/upload?publicly=false',
				files: [],
				topActive: '',
				subActive: '',
				tab: [],
				loading: false,
				craft: [],
				deviation: [{
						label: '无',
						value: '',
					},
					{
						label: '1%',
						value: 1,
					},
					{
						label: '2%',
						value: 2
					},
					{
						label: '3%',
						value: 3
					},
					{
						label: '4%',
						value: 4
					},
					{
						label: '5%',
						value: 5
					},
					{
						label: '6%',
						value: 6
					},
					{
						label: '7%',
						value: 7
					},
					{
						label: '8%',
						value: 8
					},
					{
						label: '9%',
						value: 9
					},
					{
						label: '10%',
						value: 10
					}
				],
				data: []
			}
		},
		props: {
			formLabelWidth: {
				type: [String]
			}
		},
		watch: {
			"form.equipmentId": {
				handler(n, o) {
					if (n !== o) {
						this.getTab()
						this.getCraftTemplate()
					}
				},
				immediate: false,
				deep: true
			},
		},
		methods: {
			switchView() {
				this.type = this.type === 1 ? 2 : 1
				let params = {
					equipmentId: this.form.equipmentId,
					startTime: 1641284723802
				}
				// this.dialogTime = this.dateFormat(row.time)
				return this.http.get('/web/craft/snapshoot/parameter?' + this.qs.stringify(params)).then(response => {
					this.gkHtml = response.data.gk
					this.gyHtml = response.data.gy
					this.tjHtml = response.data.tj
				})
			},
			// 获取tab
			getTab() {
				const params = {
					equipmentId: this.form.equipmentId
				}
				return this.http.get('/web/equipment/getEquipmentAndBelongEquipments?' + this.qs.stringify(params)).then(
					response => {
						this.tab = response.data || []
						console.log('jjjjj', this.tab)
						if (!this.tab.length == '') {
							this.topActive = this.tab[0]['name']
						}

					})
			},
			// 获取工艺参数
			getCraftTemplate() {
				const params = {
					equipmentId: this.form.equipmentId
				}
				if (this.form.equipmentId) {
					// /craft/guide/getCreaftTemplateByEquipmentId?equipmentId=8983
					return this.http.get('/web/manage/craft/guide/getCreaftTemplateByEquipmentId?' + this.qs.stringify(
							params))
						.then(response => {
							this.$nextTick(() => {
								const data = response.data
                if(data==''){
                  this.form.craftGuideParams = []
                }
								if (data.length > 0) {
									for (let i = 0; i < data.length; i++) {
										let params = []
										for (let j = 0; j < data[i]['data'].length; j++) {
											params.push({
												"type": data[i]['dict'],
												"tabName": this.$t(
													this.store.state.dictJson[
														"EQUIPMENT_CRAFT_CLASSIFICATION"]
													[
														data[i]["dict"]
													]
												),
												name:this.$t(data[i]['data'][j]['i18n'])  +this.$t(data[i]['data'][j]['unit']),
												code: data[i]['data'][j]['code'],
												value: data[i]['data'][j]['value'],
												upperLimit: '',
												lowerLimit: '',
												percent: ''
											})
										}
										data[i]['params'] = params
									}
									const subTab = []
									for (let i = 0; i < data.length; i++) {
										subTab.push({
											"type": data[i]['dict'],
											"tabName": this.$t(
												this.store.state.dictJson[
													"EQUIPMENT_CRAFT_CLASSIFICATION"][
													data[i]["dict"]
												]
											),
											"equipmentId": this.form.equipmentId,
											"params": data[i]['params']
										})
									}

									this.$set(this.form, "craftGuideParams", subTab)
									this.subActive = this.form.craftGuideParams[0]['tabName']
								}
							})

						})
				} else {
					if (!this.form.equipmentId)
						this.form.craftGuideParams = []
					this.topActive = []
					this.tab = []
				}

			},

			// 全局偏差修改
			changeAllDeviation(value) {
        setTimeout(() => {
          if (this.form.craftGuideParams.length > 0) {
            for (let i = 0; i < this.form.craftGuideParams.length; i++) {
              if (this.form.craftGuideParams[i]['params'].length > 0) {
                for (let j = 0; j < this.form.craftGuideParams[i]['params'].length; j++) {
                  this.$set(this.form.craftGuideParams[i]['params'][j],'upperLimit', (0.01 * value * this.form.craftGuideParams[i]['params'][j]['value']).toFixed(2));
                  this.$set(this.form.craftGuideParams[i]['params'][j],'lowerLimit',(0.01 * value * this.form.craftGuideParams[i]['params'][j]['value']).toFixed(2));
                  this.$set(this.form.craftGuideParams[i]['params'][j],'percent',value);
                }
              }
            }
          }
        }, 100);
			},
			// 单项偏差修改
			changeDeviation(index, type, value) {
				for (let i = 0; i < this.form.craftGuideParams.length; i++) {
					if (this.form.craftGuideParams[i]['params'].length > 0 && this.form.craftGuideParams[i]['type'] ===
						type) {
						if (this.form.craftGuideParams[i]['params'][index]['value']) {
							this.$set(
								this.form.craftGuideParams[i]['params'][index],
								'upperLimit',
								(0.01 * value * this.form.craftGuideParams[i]['params'][index]['value']).toFixed(2)
							)
							this.$set(
								this.form.craftGuideParams[i]['params'][index],
								'lowerLimit',
								(0.01 * value * this.form.craftGuideParams[i]['params'][index]['value']).toFixed(2)
							)
						}
					}
				}
			}
		}
	}
</script>
